import { Link } from "react-router-dom";
import { allArticles } from "@/mocks/articles";

export default function ArticlePreviewSection() {
  return (
    <section id="guides" className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-4">
            Guides &amp; Tips
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            Latest Kakobuy Spreadsheet Guides
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Expert tips, buying guides, and comprehensive resources to help you get the most out of your kakobuy spreadsheet experience. Updated daily.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {allArticles.map((article) => (
            <Link
              key={article.id}
              to={`/guide/${article.slug}`}
              className="group card block cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-52 overflow-hidden bg-background-100">
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                  style={{
                    backgroundImage: `url(${article.image})`,
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-0.5 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full">
                    {article.readTime}
                  </span>
                  <span className="px-2 py-0.5 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full">
                    {article.date}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 whitespace-nowrap">
                  Read Full Guide
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}